import { LocationDetailsModel } from './location_details.model';

export class LocationType {
    lctId: string;
    lctName: string;
    lctIcon: string;
    lctIsSelected: boolean;
    checked?: boolean;
    locationDetails: LocationDetailsModel[];
}